import { TranslationFunction } from 'i18next'
import React, { SFC } from 'react'

import { i18nKeys } from '../../../app.i18n'
import { AssessmentValue } from '../review'

type SmileProps = {
  value: number
  t: TranslationFunction
}
export const Smile: SFC<SmileProps> = ({ value, t }) => {
  return (
    <span className="icon">
      {value === AssessmentValue.ExceptionallyGood && t(i18nKeys.frontFace.reviews.ratingIcon.exceptionallyGood)}
      {value === AssessmentValue.Successful && t(i18nKeys.frontFace.reviews.ratingIcon.successful)}
      {value === AssessmentValue.AtTheEdge && t(i18nKeys.frontFace.reviews.ratingIcon.atTheEdge)}
      {value === AssessmentValue.NotThatGood && t(i18nKeys.frontFace.reviews.ratingIcon.notThatGood)}
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/app/front-face/shared/smile/smile.tsx